export const SUBJECT_LIST_REQUEST = 'SUBJECT_LIST_REQUEST';
export const SUBJECT_LIST_SUCCESS = 'SUBJECT_LIST_SUCCESS';
export const SUBJECT_LIST_FAIL = 'SUBJECT_LIST_FAIL';

export const SUBJECT_DETAILS_REQUEST = 'SUBJECT_DETAILS_REQUEST';
export const SUBJECT_DETAILS_SUCCESS = 'SUBJECT_DETAILS_SUCCESS';
export const SUBJECT_DETAILS_FAIL = 'SUBJECT_DETAILS_FAIL';
export const SUBJECT_DETAILS_RESET = 'SUBJECT_DETAILS_RESET';

export const SUBJECT_CREATE_REQUEST = 'SUBJECT_CREATE_REQUEST';
export const SUBJECT_CREATE_SUCCESS = 'SUBJECT_CREATE_SUCCESS';
export const SUBJECT_CREATE_FAIL = 'SUBJECT_CREATE_FAIL';
export const SUBJECT_CREATE_RESET = 'SUBJECT_CREATE_RESET';

export const SUBJECT_UPDATE_REQUEST = 'SUBJECT_UPDATE_REQUEST';
export const SUBJECT_UPDATE_SUCCESS = 'SUBJECT_UPDATE_SUCCESS';
export const SUBJECT_UPDATE_FAIL = 'SUBJECT_UPDATE_FAIL';
export const SUBJECT_UPDATE_RESET = 'SUBJECT_UPDATE_RESET';

export const SUBJECT_DELETE_REQUEST = 'SUBJECT_DELETE_REQUEST';
export const SUBJECT_DELETE_SUCCESS = 'SUBJECT_DELETE_SUCCESS';
export const SUBJECT_DELETE_FAIL = 'SUBJECT_DELETE_FAIL';

export const SUBJECT_DTO_REQUEST = 'SUBJECT_DTO_REQUEST';
export const SUBJECT_DTO_SUCCESS = 'SUBJECT_DTO_SUCCESS';
export const SUBJECT_DTO_FAIL = 'SUBJECT_DTO_FAIL';
export const SUBJECT_DTO_RESET = 'SUBJECT_DTO_RESET';

export const SUBJECT_LIST_BY_IDS_REQUEST = 'SUBJECT_LIST_BY_IDS_REQUEST';
export const SUBJECT_LIST_BY_IDS_SUCCESS = 'SUBJECT_LIST_BY_IDS_SUCCESS';
export const SUBJECT_LIST_BY_IDS_FAIL = 'SUBJECT_LIST_BY_IDS_FAIL';
export const SUBJECT_LIST_BY_IDS_RESET = 'SUBJECT_LIST_BY_IDS_RESET'; 